module.exports = __webpack_public_path__ + "static/media/ico-breaker.d108406a.svg";